import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';

import {
  EpCore2Module,
  EpLocalizationService,
  EpApplicationModule,
  EpShellModule,
  EpEulaModule,
  EpErpSupportModule,
  EpErpLoginModule,
  EpSelectionListModule,
  EpInputsModule,
  EpButtonsModule,
  EpToolBarModule,
  EpDropdownsModule,
  EpSearchBoxModule,
  EpTagModule,
  EpLayoutModule,
  EpBoxGridModule,
  EpRadioButtonModule
} from '@epicor/ux-platform';
// import { EpInternationalConfigService } from '@epicor/ux-platform';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AppLocalizationStrings } from './app.localization.strings';
import { AboutComponent } from './about/about.component';
import { AppCommonService } from './app.common.service';
import { SetHeaderComponent } from './set-header/set-header.component';
import { SelectServiceComponent } from './select-service/select-service.component';
import { SelectBaqComponent } from './select-baq/select-baq.component';
import { SelectEfxComponent } from './select-efx/select-efx.component';
import { ContextService } from './services/context.service';
import { HelpPageService } from './services/help-page.service';

/**
 * Localization import example.
 */
// import localeEn from '@angular/common/locales/en';
// import localeZh from '@angular/common/locales/zh';
// import localeDe from '@angular/common/locales/de';

// import '@progress/kendo-angular-intl/locales/en/all';
// import '@progress/kendo-angular-intl/locales/zh/all';
// import '@progress/kendo-angular-intl/locales/de/all';

/**
 * Register the application localization strings to be translated.
 */
EpLocalizationService.registerStrings(AppLocalizationStrings);

function initializeContext(contextService: ContextService) {
  return () => {
    // This forces ContextService constructor to run and waits for setup completion
    return contextService.initialSetupComplete.pipe().toPromise();
  };
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
    SetHeaderComponent,
    SelectServiceComponent,
    SelectBaqComponent,
    SelectEfxComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    EpShellModule,
    EpApplicationModule,
    EpEulaModule,
    EpCore2Module.forRoot(),
    EpErpSupportModule,
    EpErpLoginModule,
    EpSelectionListModule,
    EpInputsModule,
    EpButtonsModule,
    EpToolBarModule,
    EpDropdownsModule,
    EpSearchBoxModule,
    EpTagModule,
    EpLayoutModule,
    EpBoxGridModule,
    EpRadioButtonModule
  ],
  providers: [AppCommonService, ContextService, HelpPageService],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    /**
     * Register Locales.
     */
    // EpInternationalConfigService.registerLocale(localeEn, 'en');
    // EpInternationalConfigService.registerLocale(localeZh, 'zh');
    // EpInternationalConfigService.registerLocale(localeDe, 'de');
  }
}
